import type { StudyFindingsQuestion } from '@digital-twins/shared-types'
import { MarkdownBody } from '@design-system/components/MarkdownBody'
import { ThreadFeaturedExhibits } from '@/components/quick-study-results/featuredPlots/ThreadFeaturedExhibits'
import { SavedQuestionFigure } from './SavedQuestionFigure'

/** Preserve the saved question/plot binding rather than flattening its cells into generic charts. */
export function SavedFindingsQuestions({ questions, onRetry, isQuickStudy = false }: {
  questions: StudyFindingsQuestion[]
  onRetry: () => void
  /** Only a Quick Study's plots print one decimal. */
  isQuickStudy?: boolean
}) {
  return <>{questions.map((question) => <section key={question.questionId} className="space-y-3" data-testid="saved-question-findings">
    <div className="flex items-start justify-between gap-3"><h3 className="text-sm font-medium">{question.title}</h3><span className="shrink-0 text-xs text-muted-foreground">n={question.baseN}</span></div>
    {question.nativePlot ? <SavedQuestionFigure question={{ questionId: question.questionId, kind: question.nativePlot.kind, plots: { total: question.nativePlot } }}
      baseN={question.baseN} lowBase={question.lowBase} onRetry={onRetry} oneDecimalShares={isQuickStudy} />
      : <><ThreadFeaturedExhibits charts={question.charts} tables={question.tables} />{!question.charts.length && !question.tables.length ? <MarkdownBody content={question.body} density="thread" /> : null}</>}
  </section>)}</>
}
